import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [],
    imports: [CommonModule]
})
export class InterfacesModule {}

// management
export * from './management/enumerations.generated';

// providers
export * from './providers/models.generated';
export * from './providers/enums.generated';
export * from './providers/enumerations.generated';

// sub-board
export * from './sub-board/models.generated';
export * from './sub-board/enums.generated';
export * from './sub-board/enumerations.generated';
